import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import azCommon from '../locales/az/common.json';
import azNav from '../locales/az/nav.json';
import azGames from '../locales/az/games.json';
import azAuth from '../locales/az/auth.json';
import azWallet from '../locales/az/wallet.json';
import azErrors from '../locales/az/errors.json';
import azPayments from '../locales/az/payments.json';
import azWheel from '../locales/az/wheel.json';
import azLegal from '../locales/az/legal.json';
import azProfile from '../locales/az/profile.json';
import azSupport from '../locales/az/support.json';
import azVip from '../locales/az/vip.json';
import azReferral from '../locales/az/referral.json';

import ruCommon from '../locales/ru/common.json';
import ruNav from '../locales/ru/nav.json';
import ruGames from '../locales/ru/games.json';
import ruAuth from '../locales/ru/auth.json';
import ruWallet from '../locales/ru/wallet.json';
import ruErrors from '../locales/ru/errors.json';
import ruPayments from '../locales/ru/payments.json';
import ruWheel from '../locales/ru/wheel.json';
import ruLegal from '../locales/ru/legal.json';
import ruProfile from '../locales/ru/profile.json';
import ruSupport from '../locales/ru/support.json';
import ruVip from '../locales/ru/vip.json';
import ruReferral from '../locales/ru/referral.json';

import enCommon from '../locales/en/common.json';
import enNav from '../locales/en/nav.json';
import enGames from '../locales/en/games.json';
import enAuth from '../locales/en/auth.json';
import enWallet from '../locales/en/wallet.json';
import enErrors from '../locales/en/errors.json';
import enPayments from '../locales/en/payments.json';
import enWheel from '../locales/en/wheel.json';
import enLegal from '../locales/en/legal.json';
import enProfile from '../locales/en/profile.json';
import enSupport from '../locales/en/support.json';
import enVip from '../locales/en/vip.json';
import enReferral from '../locales/en/referral.json';

import kkCommon from '../locales/kk/common.json';
import kkNav from '../locales/kk/nav.json';
import kkGames from '../locales/kk/games.json';
import kkAuth from '../locales/kk/auth.json';
import kkWallet from '../locales/kk/wallet.json';
import kkErrors from '../locales/kk/errors.json';
import kkPayments from '../locales/kk/payments.json';
import kkWheel from '../locales/kk/wheel.json';
import kkLegal from '../locales/kk/legal.json';
import kkProfile from '../locales/kk/profile.json';
import kkSupport from '../locales/kk/support.json';
import kkVip from '../locales/kk/vip.json';
import kkReferral from '../locales/kk/referral.json';

import uzCommon from '../locales/uz/common.json';
import uzNav from '../locales/uz/nav.json';
import uzGames from '../locales/uz/games.json';
import uzAuth from '../locales/uz/auth.json';
import uzWallet from '../locales/uz/wallet.json';
import uzErrors from '../locales/uz/errors.json';
import uzPayments from '../locales/uz/payments.json';
import uzWheel from '../locales/uz/wheel.json';
import uzLegal from '../locales/uz/legal.json';
import uzProfile from '../locales/uz/profile.json';
import uzSupport from '../locales/uz/support.json';
import uzVip from '../locales/uz/vip.json';
import uzReferral from '../locales/uz/referral.json';

import tgCommon from '../locales/tg/common.json';
import tgNav from '../locales/tg/nav.json';
import tgGames from '../locales/tg/games.json';
import tgAuth from '../locales/tg/auth.json';
import tgWallet from '../locales/tg/wallet.json';
import tgErrors from '../locales/tg/errors.json';
import tgPayments from '../locales/tg/payments.json';
import tgWheel from '../locales/tg/wheel.json';
import tgLegal from '../locales/tg/legal.json';
import tgProfile from '../locales/tg/profile.json';
import tgSupport from '../locales/tg/support.json';
import tgVip from '../locales/tg/vip.json';
import tgReferral from '../locales/tg/referral.json';

import trCommon from '../locales/tr/common.json';
import trNav from '../locales/tr/nav.json';
import trGames from '../locales/tr/games.json';
import trAuth from '../locales/tr/auth.json';
import trWallet from '../locales/tr/wallet.json';
import trErrors from '../locales/tr/errors.json';
import trPayments from '../locales/tr/payments.json';
import trWheel from '../locales/tr/wheel.json';
import trLegal from '../locales/tr/legal.json';
import trProfile from '../locales/tr/profile.json';
import trSupport from '../locales/tr/support.json';
import trVip from '../locales/tr/vip.json';
import trReferral from '../locales/tr/referral.json';

export const SUPPORTED_LOCALES = ['az', 'ru', 'en', 'kk', 'uz', 'tg', 'tr'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: AppLocale = 'az';
export const LOCALE_STORAGE_KEY = 'vbbplay.locale';

export const LOCALE_LABELS: Record<AppLocale, string> = {
  az: 'Azərbaycan',
  ru: 'Русский',
  en: 'English',
  kk: 'Қазақша',
  uz: 'Oʻzbekcha',
  tg: 'Тоҷикӣ',
  tr: 'Türkçe',
};

const resources = {
  az: {
    common: azCommon,
    nav: azNav,
    games: azGames,
    auth: azAuth,
    wallet: azWallet,
    errors: azErrors,
    payments: azPayments,
    wheel: azWheel,
    legal: azLegal,
    profile: azProfile,
    support: azSupport,
    vip: azVip,
    referral: azReferral,
  },
  ru: {
    common: ruCommon,
    nav: ruNav,
    games: ruGames,
    auth: ruAuth,
    wallet: ruWallet,
    errors: ruErrors,
    payments: ruPayments,
    wheel: ruWheel,
    legal: ruLegal,
    profile: ruProfile,
    support: ruSupport,
    vip: ruVip,
    referral: ruReferral,
  },
  en: {
    common: enCommon,
    nav: enNav,
    games: enGames,
    auth: enAuth,
    wallet: enWallet,
    errors: enErrors,
    payments: enPayments,
    wheel: enWheel,
    legal: enLegal,
    profile: enProfile,
    support: enSupport,
    vip: enVip,
    referral: enReferral,
  },
  kk: {
    common: kkCommon,
    nav: kkNav,
    games: kkGames,
    auth: kkAuth,
    wallet: kkWallet,
    errors: kkErrors,
    payments: kkPayments,
    wheel: kkWheel,
    legal: kkLegal,
    profile: kkProfile,
    support: kkSupport,
    vip: kkVip,
    referral: kkReferral,
  },
  uz: {
    common: uzCommon,
    nav: uzNav,
    games: uzGames,
    auth: uzAuth,
    wallet: uzWallet,
    errors: uzErrors,
    payments: uzPayments,
    wheel: uzWheel,
    legal: uzLegal,
    profile: uzProfile,
    support: uzSupport,
    vip: uzVip,
    referral: uzReferral,
  },
  tg: {
    common: tgCommon,
    nav: tgNav,
    games: tgGames,
    auth: tgAuth,
    wallet: tgWallet,
    errors: tgErrors,
    payments: tgPayments,
    wheel: tgWheel,
    legal: tgLegal,
    profile: tgProfile,
    support: tgSupport,
    vip: tgVip,
    referral: tgReferral,
  },
  tr: {
    common: trCommon,
    nav: trNav,
    games: trGames,
    auth: trAuth,
    wallet: trWallet,
    errors: trErrors,
    payments: trPayments,
    wheel: trWheel,
    legal: trLegal,
    profile: trProfile,
    support: trSupport,
    vip: trVip,
    referral: trReferral,
  },
};

i18n.on('languageChanged', (lng) => {
  const primary = (lng || DEFAULT_LOCALE).slice(0, 2);
  if (isAppLocale(primary)) {
    document.documentElement.lang = primary;
  }
});

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ['az', 'en'],
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS: 'common',
    ns: ['common', 'nav', 'games', 'auth', 'wallet', 'errors', 'payments', 'wheel', 'legal', 'profile', 'support', 'vip', 'referral'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  })
  .then(() => {
    const primary = (i18n.resolvedLanguage || i18n.language || DEFAULT_LOCALE).slice(0, 2);
    if (isAppLocale(primary)) {
      document.documentElement.lang = primary;
    }
  });

export function isAppLocale(value: string | null | undefined): value is AppLocale {
  return Boolean(value && (SUPPORTED_LOCALES as readonly string[]).includes(value));
}

export function getStoredLocale(): AppLocale | null {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    return isAppLocale(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** BCP-47 tags for number/date formatting (not for provider language claims). */
export const LOCALE_FORMAT_TAGS: Record<AppLocale, string> = {
  az: 'az-AZ',
  ru: 'ru-RU',
  en: 'en-GB',
  kk: 'kk-KZ',
  uz: 'uz-UZ',
  tg: 'tg-TJ',
  tr: 'tr-TR',
};

export function formatLocaleTag(locale?: string | null): string {
  const primary = (locale || DEFAULT_LOCALE).slice(0, 2);
  return isAppLocale(primary) ? LOCALE_FORMAT_TAGS[primary] : LOCALE_FORMAT_TAGS[DEFAULT_LOCALE];
}

export function setAppLocale(locale: AppLocale): void {
  void i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore quota / private mode
  }
}

export default i18n;
